import { runClientComponent } from '../../_common/client/client-component-runner';
import { EnergyEfficiencyBaseComponentComponent } from './energy-efficiency-base-component.component';

runClientComponent({ EnergyEfficiencyComponent: EnergyEfficiencyBaseComponentComponent });
